import React from "react";
import { ShieldAlert, RefreshCw, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../GlobalContext";

export default function AccessDeniedPage({
  title = "Access Denied",
  message = "You do not have permission to access this section.",
  subMessage = "Please contact your admin or try again with a valid account.",
  onRetry,
}) {
  const navigate = useNavigate();

  const {
    setIsAccessDenied,
    setAccessDeniedMessage,
  } = useGlobalContext();

  const handleGoDashboard = () => {
    setIsAccessDenied(false);
    setAccessDeniedMessage("");
    navigate("/dashboard", { replace: true });
  };

  return (
    <div className="min-h-[70vh] w-full flex items-center justify-center px-4 py-10 bg-white">
      <div className="w-full max-w-md rounded-3xl border border-red-100 bg-white p-6 sm:p-8 text-center shadow-xl shadow-red-100/50">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-red-50 text-red-600">
          <ShieldAlert size={34} />
        </div>

        <h2 className="text-2xl font-bold text-slate-900">{title}</h2>

        <p className="mt-3 text-sm leading-6 text-slate-600">{message}</p>

        <p className="mt-2 text-xs leading-5 text-slate-500">{subMessage}</p>

        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              className="inline-flex items-center justify-center gap-2 rounded-xl bg-red-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700"
            >
              <RefreshCw size={16} />
              Retry
            </button>
          )}

          <button
            type="button"
            onClick={handleGoDashboard}
            className="inline-flex items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
          >
            <Home size={16} />
            Go Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}